"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _utils.unstable_generateUtilityClasses;
    }
});
var _utils = require("@mui/utils");
